// import { mathCalculators } from "../Id/MathCalculator/ConstantsMathCalculator";
import { womenCalculators } from "../Id/WomenCalculator/ConstantsWomenCalculator";
import { financialCalculators } from "../Id/FinancialCalculator/ConstantsFinancialCalculator";
import { humanCalculators } from "../Id/HumanCalculator/ConstantsHumanCalculator";
import { islamicCalculators } from "../Id/IslamicCalculator/ConstantsIslamicCalculator";
import { studyCalculators } from "../Id/StudyCalculator/ConstantsStudyCalculator";
import { physicsCalculators } from "../Id/PhysicsCalculator/ConstantsPhysicsCalculator";
import { healthCalculators } from "../Id/HealthCalculator/ConstantsHealthCalculator";
import { otherCalculators } from "../Id/OtherCalculator/ConstantsOtherCalculator";
import { chemistryCalculators } from "../Id/ChemistryCalculator/ConstantsChemistryCalculator";
import { foodCalculators } from "./FoodCalculator/ConstantsFoodCalculator";
import SharedHelmet from "./Helmet";
import { useState } from "react";
import { Icons } from "../../Components/Icons";

const TITLE = "Semua Kalkulator";
const DESCRIPTION = "Di sini Anda dapat menemukan semua kalkulator di situs Ahsib";
const KEYWORDS = "semua kalkulator";
const OG_URL = "https://do-calculate.com/id/all-calculators/";

const cardData = [
  {
    cardNumber: 12,
    cardTitle: "Kalkulator Makanan",
    cardIcon: <Icons.Food />,
    cardItems: foodCalculators,
    calculatorUrl: "/id/food-calculators/",
  },

  {
    cardNumber: 3,
    cardTitle: "Kalkulator Wanita",
    cardIcon: <Icons.Female />,
    cardItems: womenCalculators,
    calculatorUrl: "/id/women-calculators/",
  },
  {
    cardNumber: 5,
    cardTitle: "Kalkulator Zakat",
    cardIcon: <Icons.VolunteerActivism />,
    cardItems: islamicCalculators,
    calculatorUrl: "/id/zakat-calculators/",
  },

  {
    cardNumber: 9,
    cardTitle: "Kalkulator Keuangan",
    cardIcon: <Icons.AttachMoney />,
    cardItems: financialCalculators,
    calculatorUrl: "/id/financial-calculators/",
  },
  {
    cardNumber: 1,
    cardTitle: "Kalkulator Waktu dan Tanggal",
    cardIcon: <Icons.AccessTime />,
    cardItems: humanCalculators,
    calculatorUrl: "/id/date-time-calculators/",
  },
  {
    cardNumber: 10,
    cardTitle: "Kalkulator Lainnya",
    cardIcon: <Icons.MoreHoriz />,
    cardItems: otherCalculators,
    calculatorUrl: "/id/other-calculators/",
  },
  {
    cardNumber: 6,
    cardTitle: "Kalkulator Nilai Universitas",
    cardIcon: <Icons.School />,
    cardItems: studyCalculators,
    calculatorUrl: "/id/study-calculators/",
  },
  {
    cardNumber: 7,
    cardTitle: "Kalkulator Fisika",
    cardIcon: <Icons.Science />,
    cardItems: physicsCalculators,
    calculatorUrl: "/id/physics-calculators/",
  },
  {
    cardNumber: 2,
    cardTitle: "Kalkulator Kesehatan dan Kebugaran",
    cardIcon: <Icons.Favorite />,
    cardItems: healthCalculators,
    calculatorUrl: "/id/health-calculators/",
  },
  // {
  //   cardNumber: 4,
  //   cardTitle: "Kalkulator Matematika",
  //   cardIcon: <Icons.Calculate />,
  //   cardItems: mathCalculators,
  //   calculatorUrl: "/id/math-calculators/",
  // },
  {
    cardNumber: 8,
    cardTitle: "Kalkulator Kimia",
    cardIcon: <Icons.Biotech />,
    cardItems: chemistryCalculators,
    calculatorUrl: "/id/chemistry-calculators/",
  },
];

function CardGroups() {
  const [searchTerm, setSearchTerm] = useState("");
  const filteredCardData = cardData.filter((card) =>
    card.cardItems.some((item) =>
      item.name.toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  return (
    <div style={{ direction: "ltr" }}>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div
        className="row row-cols-1 row-cols-md-4 g-4"
        style={{ position: "relative", zIndex: "1" }}
      >
        {filteredCardData.map((card, index) => (
          <div className="col" xs key={index} style={{ paddingBottom: "10px" }}>
            <div>
              <h2 style={{ fontSize: "16px" }}>
                {card.cardIcon} {card.cardTitle}
              </h2>
              <ul style={{ padding: 0, listStyleType: "none" }}>
                {card.cardItems.map((item, itemIndex) => (
                  <li key={itemIndex}>
                    <a
                      href={item.link}
                      className="item-link"
                      style={{ fontSize: "14px" }}
                    >
                      {item.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
      <hr />
      <div className="p-3 mb-2 bg-success text-white">
        Jika Anda memiliki pertanyaan, ingin tim kami menambahkan kalkulator lain, atau ingin melaporkan masalah pada kalkulator tertentu, harap beri tahu kami melalui email berikut: info@do-calculate.com
      </div>
    </div>
  );
}

export default CardGroups;